
import lastEvaluateMatchMixin from '@/mixins/lastEvalutateMatchMixin'
import StepTwoBase from '@/components/Experiences/StepTwoBase.vue'
import skillMorphsTypes from '~/constants/skill-morphs'
import { getSuggestSkillsForExperienceEducational } from '~/util/entity/experience'
import EDUCATIONAL_TYPES from '~/constants/educational-types'
const { ENTITY_TYPES, ORIGIN_TYPES } = skillMorphsTypes

export default {
  name: 'StepTwoEducationals',
  extends: StepTwoBase,
  mixins: [lastEvaluateMatchMixin],
  methods: {
    getSuggestSkills(experience, userSkills) {
      return getSuggestSkillsForExperienceEducational(
        this.$repository,
        experience,
        userSkills
      )
    },
    prepareSkillsMorphs() {
      const suggestSkillIds = this.suggestSkills.map((skill) => skill.id)
      return this.skillsSelected.map((skill) => ({
        related_type: ENTITY_TYPES.EXPERIENCE_EDUCATIONALS,
        related_id: this.experience.id,
        user: this.$strapi.user.id,
        skill,
        has_skill: true,
        origin_type: suggestSkillIds.includes(skill)
          ? ORIGIN_TYPES.SUGGEST
          : ORIGIN_TYPES.FREE,
      }))
    },
    updatedTotalHasSkills() {
      return this.$repository.experienceEducational.updateTotalHasSkills(
        this.experience.id,
        {
          total_has_skills: this.skillsSelected.length,
        }
      )
    },
    async saveSkills() {
      const skillMorphs = this.prepareSkillsMorphs()

      if (skillMorphs.length === 0) return

      const userId = this.$strapi.user.id

      const savedSkills = await this.$repository.skillMorph.saveMassive(
        userId,
        this.experience?.id,
        ENTITY_TYPES.EXPERIENCE_EDUCATIONALS,
        skillMorphs
      )
      this.evaluateMatchUser(userId)
      return savedSkills
    },
    getIsDefaultSetSkills(experience) {
      if (
        experience.educational_type.name === EDUCATIONAL_TYPES.TECHNICAL_COLLEGE
      ) {
        return false
      }
      return !experience.occupation
    },
  },
}
